import Service from "./Service";
import AdminService from "./AdminService";

const route = "/contactData";

class ContactService extends AdminService
{
  constructor ()
  {
    super(route, {
      defaultRoutes: [
        Service.ROUTE_MAP.GET
      ],
      authenticated: true
    });
  }
}

export default ContactService;